
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 8.333h.666V7h.667a.645.645 0 00.475-.192A.645.645 0 008 6.333v-.666a.645.645 0 00-.192-.475A.645.645 0 007.333 5H6v3.333zm.666-2v-.666h.667v.666h-.667zm2 2H10a.645.645 0 00.475-.191.645.645 0 00.191-.475v-2a.645.645 0 00-.191-.475A.645.645 0 0010 5H8.666v3.333zm.667-.666v-2H10v2h-.667zm2 .666H12V7h.666v-.667H12v-.666h.666V5h-1.333v3.333zm-6 3.667c-.367 0-.68-.13-.942-.392A1.284 1.284 0 014 10.667v-8c0-.367.13-.68.391-.942.261-.261.575-.392.942-.392h8c.367 0 .68.13.942.392.26.261.391.575.391.942v8c0 .366-.13.68-.391.941a1.284 1.284 0 01-.942.392h-8zm-2.667 2.667c-.366 0-.68-.13-.941-.392a1.284 1.284 0 01-.392-.942V4h1.333v9.333H12v1.334H2.666z"}})])
          )
        }
      }
    